import Vue from 'vue';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'login',
    components: {},
    props: {
        importName: {
            type: String,
            default: '',
            required: true,
        },
        dialogCampany: {
            type: Boolean,
        },
    },
    computed: {},
    data: function () {
        return {
            showUpload: true,
            btnName: '',
            file: {},
            uploadUrl: '',
            usernameZh: '',
            loadingMain: null,
        };
    },
    created: function () {
        this.uploadUrl =
            this.importName === '所属公司'
                ? '/proxy/file/company/batch/import'
                : '/proxy/file/company/batch/import';
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        beforeAvatarUpload: function (file) {
            var fileArr = file.name.split('.');
            var name = fileArr[fileArr.length - 1];
            var reg = /^xlsx|xls$/;
            if (!reg.test(name)) {
                this.$confirm('', '', {
                    message: '<p class="title">仅支持xlsx或xls格式文件</p>',
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '知道了',
                    showClose: false,
                    type: 'error',
                    showCancelButton: false,
                });
                return false;
            }
        },
        customRequest: function (_a) {
            var file = _a.file;
            this.file = file;
            this.showUpload = false;
            this.btnName = file.name;
        },
        submitForm: function () {
            var _this = this;
            var url = this.importName === '所属公司'
                ? '/proxy/file/batch/company/import'
                : '/proxy/file/batch/company/import';
            this.loadingMain = Vue.prototype.$loading({
                spinner: 'el-icon-loading',
                background: 'rgba(300, 300, 300, 0.5)',
                customClass: 'loading',
                body: true,
            });
            this.$request({
                method: 'post',
                url: url,
                data: {
                    file: this.file,
                    creator: this.usernameZh,
                },
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                loadingControl: 'hand',
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (data[key] != null) {
                            formData.append(key, data[key]);
                        }
                    }
                    return formData;
                },
            }).then(function (res) {
                if (!res) {
                    return _this.loadingMain.close();
                }
                if (!res.errorCode) {
                    var key = res.data;
                    _this.realGetImportPro(key);
                }
            });
        },
        getImportPro: function (key) {
            return this.$request({
                method: 'post',
                url: "/proxy/api/batch/import/progress",
                data: {
                    uploadKey: key,
                },
                loadingControl: 'hand',
            });
        },
        realGetImportPro: function (key) {
            var _this = this;
            var timer = null;
            var pollingMain = function () {
                _this.getImportPro(key).then(function (res) {
                    if (!res || res.errorCode) {
                        clearTimeout(timer);
                        _this.$alert('', '', {
                            message: "<p class=\"title\">" + _this.importName + "\u5BFC\u5165\u51FA\u9519\u4E86</p><p class=\"text\">" + res.errorMsg + "</p>",
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '知道了',
                            type: 'error',
                            showClose: false,
                        }).then(function () {
                            _this.$emit('shutDiglog');
                        });
                        return _this.loadingMain.close();
                    }
                    if (!res.errorCode && res.data.finished) {
                        clearTimeout(timer);
                        if (!res.errorCode && res.data.total > res.data.success) {
                            _this.$confirm('', '', {
                                message: "<p class=\"title\">\u6279\u91CF\u5BFC\u5165\u5B8C\u6210\uFF0C" + res.data.failure + "\u6761\u5BFC\u5165\u5931\u8D25</p><p class=\"text\">\u6210\u529F\u5BFC\u5165" + res.data.success + "\u6761" + _this.importName + "\u4FE1\u606F\uFF0C" + res.data.failure + "\u6761\u5BFC\u5165\u5931\u8D25\uFF0C\u8BF7\u4E0B\u8F7D\u6709\u8BEF\u7684\u4FE1\u606F\uFF0C\u4FEE\u6539\u540E\u91CD\u65B0\u5BFC\u5165</p>",
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '下载信息',
                                cancelButtonText: '确定',
                                type: 'warning',
                                showClose: false,
                            })
                                .then(function () {
                                _this.showUpload = true;
                                window.open(res.data.url);
                            })
                                .catch(function () {
                                _this.showUpload = true;
                            });
                        }
                        if (!res.errorCode && res.data.total === res.data.success) {
                            _this.$message({
                                message: res.data.total + "\u4E2A" + _this.importName + "\u5DF2\u6210\u529F\u5BFC\u5165",
                                type: 'success',
                            });
                            _this.showUpload = true;
                            _this.$emit('shutDiglog');
                        }
                        return _this.loadingMain.close();
                    }
                    timer = setTimeout(function () {
                        pollingMain();
                    }, 1000);
                });
            };
            pollingMain();
        },
        cancelEdit: function () {
            this.$emit('shutDiglog');
        },
        sureEdit: function () {
            this.$emit('sureEdit');
        },
        deleteFile: function () {
            this.showUpload = true;
            this.btnName = '';
            this.$refs['upload'].clearFiles();
        },
    },
    watch: {
        dialogCampany: function (val) {
            val && this.deleteFile();
        },
    },
});
